/* eslint-disable max-len */
import handleCallbackAction from '@functions/handleCallbackAction'
import substituteRouteParams from '@functions/substituteRouteParams'

import useCurrentUser from '@hooks/useCurrentUser'
import useUser from '@hooks/useUser'

const routes = {
  editTemplatePage: ({ isBrandUser }: { isBrandUser: boolean }) => {
    if (isBrandUser) return '/admin/brandhub#/templates/edit-page/:templatePageId'
    return '/admin/templates/manage#/edit-page/:templatePageId'
  },
  editTemplatePartial: ({ isBrandUser }: { isBrandUser: boolean }) => {
    if (isBrandUser){
      return '/admin/brandhub#/templates/edit-partial/:templatePagePartialId'
    }
    return '/admin/templates/manage#/edit-partial/:templatePagePartialId'
  },
}

type RouteKey = keyof typeof routes

type RedirectUrlParams = {
  key: RouteKey,
  params: { [key: string]: number },
}

type UseLoginToRealhubParams = {
  redirect: RedirectUrlParams,
}

function useLoginToRealhub(params: UseLoginToRealhubParams) {
  const { redirect } = params

  const currentUserPayload = useCurrentUser()
  const { currentUser, isBrandUser } = currentUserPayload

  // redirect.key = 'editTemplatePage'
  const routeFn = routes[redirect.key]
  const rawRoute = routeFn({ isBrandUser }) // `/admin/brandhub#/templates/edit-page/:templatePageId`
  const redirectUrl = substituteRouteParams({ route: rawRoute, routeParams: redirect.params })

  const { callbacks: { loginToRealhub } } = useUser({ id: currentUser.id })

  const loginToRealhubPayload = {
    callbacks: {
      action: loginToRealhub,
      buildActionParams: () => [{ redirect: redirectUrl }],
    },
    shouldRedirect: true,
    toastText: 'Logged In',
  }

  return {
    callbacks: {
      // @ts-expect-error TS2345
      loginToRealhub: () => handleCallbackAction(loginToRealhubPayload),
    },
    isBrandUser,
    redirectUrl,
  }
}

export default useLoginToRealhub
